import React, {useEffect, useState} from "react";
import classnames from "classnames";
import styles from "../FormTextInput/FormTextInput.module.scss";
import FormInputLoader from "../FormInputLoader/FormInputLoader";
import {TextInput} from "@instructure/ui-text-input";


// ** Class working component
class IasFormTextInput extends React.Component {
    state = {
        value: ""
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.reset !== this.props.reset && this.props.reset) {
            this.setState({
                value: ""
            });
        }
    }

    handleChange = (event, { value }) => {

    };

    handleTextChange = (name, { value }) => {

    };

    render() {
        const { value, size, label, id, name, placeholder, isDisabled, type = "text", messages } = this.props;
        const { isLoading } = this.props;
        return (
            <div className={classnames(styles.FormTextInput)}>
                <TextInput
                    renderLabel={label}
                    value={value}
                    onChange={this.props.onChange}
                    onFocus={this.props.onChange}
                    size={size}
                    display="inline-block"
                    interaction={isLoading || isDisabled ? "disabled" : "enabled"}
                    placeholder={placeholder}
                    name={name}
                    id={id}
                    type={type}
                    messages={messages}
                >
                </TextInput>
            </div>
        );
    }
}

export default IasFormTextInput;